/**
 * Performance Dashboard Live Simulation & Telemetry
 */
(function() {
  'use strict';

  function initPerformanceDashboard() {
    const dashboard = document.querySelector('.dashboard-window');
    if (!dashboard) return;

    // Add subtle interactive pulse on dashboard hover
    dashboard.addEventListener('mouseenter', function() {
      const pulseBadges = dashboard.querySelectorAll('.text-emerald-400');
      pulseBadges.forEach(function(badge) {
        badge.style.transition = 'transform 0.2s ease';
        badge.style.transform = 'scale(1.03)';
      });
    });

    dashboard.addEventListener('mouseleave', function() {
      const pulseBadges = dashboard.querySelectorAll('.text-emerald-400');
      pulseBadges.forEach(function(badge) {
        badge.style.transform = 'scale(1)';
      });
    });
  }

  window.GinaPerformanceDashboard = { init: initPerformanceDashboard };
})();
